import { render, staticRenderFns } from "./ApplicationOwners.vue?vue&type=template&id=5d7ce3ee&"
import script from "./ApplicationOwners.vue?vue&type=script&lang=ts&"
export * from "./ApplicationOwners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports